import { createContext, useContext } from 'react';

export type DebugPanelContextValue = {
  open: () => void;
};

export const DebugPanelContext = createContext<DebugPanelContextValue>({
  open: () => {},
});

export const useDebugPanel = (): DebugPanelContextValue => useContext(DebugPanelContext);
